module.exports = __webpack_public_path__ + "img/arrow-right-red.1e7145c1.svg";